/* eslint-disable react-hooks/rules-of-hooks */
import React from "react";
import { useAuth } from "../../contexts/auth/AppAuthContext";
import { Roles } from "../../firestore/Types/PermissionSchema";
import { doSignOut } from "../../firebase/auth";
import { Navigate, useNavigate } from "react-router-dom";
import { UserDetails } from "../../components/Account/UserDetails";
import { VerifyLoggedIn } from "./VerifyLoggedIn";
import { LoggedInLayoutSelector } from "../../Layouts/LoggedInLayoutSelector";
import { StudentDetails } from "../../components/Account/StudentDetails";
import { TutorExclusiveComponents } from "../../components/Account/TutorExclusiveComponents";
import { School } from "../../components/Account/School";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRightFromBracket, faCircleQuestion } from "@fortawesome/free-solid-svg-icons";

export function Account() {
    const { permission, account, refreshAccount } = useAuth();
    const navigate = useNavigate();
    const clearCacheData = () => {
        caches.keys().then((names) => {
            names.forEach((name) => {
                caches.delete(name);
            });
        });
    };

    const handleSignOut = async () => {
        clearCacheData();
        await doSignOut();
    }
    const contactUs = async () => {
        navigate(`/contact-us`);
    }
    if (permission.Role === Roles.Tutor || permission.Role === Roles.User || permission.Role === Roles.Admin) {
        return (
            <LoggedInLayoutSelector>
                <VerifyLoggedIn />
                <div className="main-bg">
                    <div className="gap-4 grid grid-cols-12 m-auto md:max-w-[900px]">
                        <div className="md:col-span-6 max-md:col-span-12">
                            <UserDetails></UserDetails>
                            <div className="section-box mt-2">
                                <School account={account} refreshAccount={refreshAccount} />
                            </div>
                            <div className="section-box mt-2 flex flex-row">
                                <div className="grow text-sm gap-4 flex flex-row">
                                    <div className="pt-2">Need help? Contact us</div>
                                    <button className="primary-button" onClick={contactUs}><FontAwesomeIcon icon={faCircleQuestion} />Help</button>
                                </div>
                               
                                <button className="primary-button" onClick={handleSignOut}> <FontAwesomeIcon icon={faArrowRightFromBracket} />Log Out</button>
                            </div>
                        </div>
                        {(permission.Role === Roles.Tutor ? <TutorExclusiveComponents/> : "")}
                        {(permission.Role === Roles.User ? StudentExclusiveComponents() : "")}
                    </div>
                </div>
            </LoggedInLayoutSelector>
        );
    }
    else {
        return <Navigate to="/login" replace />;
    }


    function StudentExclusiveComponents() {
        return (
            <div className="gap-4 flex flex-col md:col-span-6 max-md:col-span-12">
            <StudentDetails />
            </div>);
    }
}
